import { Box, MenuItem, Select, Checkbox, Button, Modal, Typography, Pagination, CircularProgress, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { FaFileExcel, FaFilePdf, FaPlus, FaWindowClose } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteNodeChildModel } from "../components/deleteNodeChildModel";
import DeleteModal from "../components/delete_modal";
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { toast } from "react-toastify";
import WarningModal from "../components/WarningModal";
import { selectnodess } from "../redux/nodesSlice";
import { AddChildNode } from "../components/addChildNodeModel";
import LoadingOverlay from "../mui/LoadingOverlay";
import { ShowBranchesModel } from "../components/showBranchesModal";
import TableMuiCustom from "../mui/TableMuiCustom";
import OrganizationModal from "../components/OrganizationModal";
import { selectAdmin, selectDevice } from "../redux/adminSlice";
import {jsPDF} from "jspdf";
import { autoTable } from 'jspdf-autotable'
import * as XLSX from 'xlsx';
import { selectgroups } from "../redux/businessSlice";
import { orgwarndata } from "../redux/websocketSlice";
import { setPlusClicked } from "../redux/nodePositionedSlice";
import { useDeleteOrganizationMutation, useUpdateOrganizationMutation } from "../redux/organizationApi";
import getHongKongTimestamp from "../utils/getHongKongTime";

function ChildOrganizations() {
  const warndata = useSelector(orgwarndata);
  const deviceId = useSelector(selectDevice);
  const [singledata, setSingleData] = useState();
  const [detail, setDetail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [datafordelete, setdatafordelete] = useState([]);
  const admin = useSelector(selectAdmin);
  console.log(admin?.permissions, "this is admin permissions");
  const [showBranch, setshowBranch] = useState(false);
  const [sharedata, setSharedata] = useState(0);
  const [node, setnode] = useState({});
  const [node1, setnode1] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDeleteModal1, setOpenDeleteModal1] = useState(false);
  const [deleteopen, setDeleteopen] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    general: {},
    shareholders: [],
    directors: [],
    JointVentureCompanies: [],
    additionalFields: []
  });

  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);

  const [sortKey, setSortKey] = useState("companyName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [selected, setSelected] = useState([]);

  const dispatch = useDispatch();
  const [updateOrganization, { isLoading: isUpdating }] = useUpdateOrganizationMutation();
  const [deleteOrganization, { isLoading: isDeleting }] = useDeleteOrganizationMutation();
  const initialNode = {
    companyName: "",
    location: {
      name: "", address: "", lat: "", lng: "", countryName: ""
    },
    totalNoOfShares: 0,  // Ensure this is a number
    directors: [""],
    shareHolders: [
      {
        childId: "",
        numberSharesOwned: "",
        PercentageOfShares: 0,
        numberofpreferenceshares: 0,
        percentageofpreferanceshares: 0
      },
    ],
    BusinessNature: "",
    Incorporationdate: "",
    CompanyRegistrationNumber: "",
    BusinessRegistrationNumber: "",
    ManagingDirector: "",
    DeputyManagingDirector: "",
    Chairman: "",
    DeputyChairman: "",
    CompanySecretary: "",
    StatutoryAuditor: "",
    RepresentativeDirector: "",
    LegalRepresentative: "",
    registerCurrency: "",
    IssuedPaidupCapital: "",
    Remarks: "",
    ParValueofShares: "",
    TotalPaidUpPremiumtoShares: "",
    isJointVentureCompany: false,
    JointVentureCompanies: [],
  };

  const [nodeData, setNodeData] = useState(initialNode);
  const allorganization = useSelector(selectnodess);
  const [childOrganizations, setChildOrganizations] = useState([]);
  const groups = useSelector(selectgroups);
  const groupfilter = (id) => {
    if (!Array.isArray(groups)) {
      return "—";
    }
    const data = groups.find((item) => item._id === id)
    return data?.businessNature ?? "—";
  }

  useEffect(() => {
    setLoading(false);
  }, [allorganization?.length]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
    border: "none !important",
  };
  const requiredFields = [
    { key: "location", message: "Location is required" },
    { key: "companyName", message: "Company Name is required" },
    { key: "BusinessNature", message: "Business Nature is required" },
    { key: "Incorporationdate", message: "Incorporation date is required" },
    { key: "CompanyRegistrationNumber", message: "Company Registration Number is required" },

    { key: "totalNoOfShares", message: "Total No of Shares is required" },
  ];

  const validateInput = () => {
    const errorObject = {
      general: {},
      shareholders: [],
      JointVentureCompanies: [],
      additionalFields: [], // Initialize additionalFields as an empty array
    };

    // Validate required fields for general company information
    requiredFields?.forEach((field) => {
      if (
        !nodeData[field.key] ||
        (field.key === "location" &&
          (!nodeData.location.name ||
            !nodeData.location.address ||
            nodeData.location.lat === null ||
            nodeData.location.lng === null))
      ) {
        errorObject.general[field.key] = field.message;
      }
    });

    // Validate Shareholders
    nodeData.shareHolders?.forEach((shareholder, index) => {
      const shareholderErrors = {};
      if (!shareholder.childId) {
        shareholderErrors.childId = "Shareholder is required";
      }
      if (!shareholder.numberSharesOwned) {
        shareholderErrors.numberSharesOwned = "Number of Ordinary Shares is required";
      }
      const selectedParents = nodeData.shareHolders?.map((sh) => sh.childId);
      if (selectedParents.indexOf(shareholder.childId) !== index) {
        shareholderErrors.childId = "Shareholder is already added";
      }
      errorObject.shareholders[index] = shareholderErrors;
    });

    // Validate Additional Fields
    nodeData?.additionalFields?.forEach((obj, index) => {
      const errorsdata = {};
      if (obj?.fieldName.trim() === "") {
        errorsdata.fieldName = "Field name is required";
      }
      if (obj?.fieldValue.trim() === "") {
        errorsdata.fieldValue = "Field value is required";
      }
      errorObject.additionalFields[index] = errorsdata;
    });

    // Validate Joint Venture Companies
    if (nodeData?.JointVentureCompanies?.length) {
      nodeData.JointVentureCompanies?.forEach((company, index) => {
        const companyErrors = {};
        if (!company.companyName || company.companyName === "") {
          companyErrors.companyName = "Company Name is required";
        }
        if (!company.numberSharesOwned) {
          companyErrors.numberSharesOwned = "Number of Shares is required";
        }
        errorObject.JointVentureCompanies[index] = companyErrors;
      });
    }

    setErrors(errorObject);

    return (
      Object.keys(errorObject.general).length === 0 &&
      errorObject.shareholders.every((e) => Object.keys(e).length === 0) &&
      errorObject.additionalFields.every((e) => Object.keys(e).length === 0) &&
      errorObject.JointVentureCompanies.every((e) => Object.keys(e).length === 0)
    );
  };
  const handleClose = () => {
    setOpen(false);
    dispatch({
      type: "alertremove", payload: {
        id: nodeData._id || nodeData?.nodeId,
        message: "Another users also edit this business group"
      }
    })

  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(value, "this is target")
    setNodeData((prevData) => ({
      ...prevData,
      [name]: value,

    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setNodeData((prevData) => ({
      ...prevData,
      imageFile: file,
      preview: URL.createObjectURL(file),
    }));
  };

  const handelDirector = (index, name) => {
    const newNames = [...(nodeData.directors || [])];
    newNames[index] = name;
    setNodeData((prev) => ({ ...prev, directors: newNames }));
  };

  const handleAddDirector = () => {
    setNodeData((prev) => ({ ...prev, directors: [...(prev.directors || []), ""] }));
  };

  const handelAddShareHolder = () => {
    setNodeData((prev) => ({
      ...prev,
      shareHolders: [
        ...prev.shareHolders,
        {
          companyName: "",
          totalNoOfShares: "",
          PercentageOfShares: 0,
        },
      ],
    }));
  };

  const handleShareHolders = (index, field, value) => {
    const updatedShareHolders = [...(nodeData.shareHolders || [])];
    updatedShareHolders[index] = {
      ...updatedShareHolders[index],
      [field]: value,
    };
    if (field === "totalNoOfShares" && nodeData.totalNoOfShares > 0) {
      updatedShareHolders[index].PercentageOfShares =
        (value / nodeData.totalNoOfShares) * 100;
    }

    setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
  };

  const handleTotalSharesChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);
    setSharedata(totalShares);
    setNodeData((prevData) => {
      const updatedShareHolders = prevData.shareHolders?.map((sh) => ({
        ...sh,
        PercentageOfShares:
          totalShares > 0 ? (sh.numberSharesOwned / totalShares) * 100 : 0,
      }));

      const updatedJointVentureCompanies = prevData.JointVentureCompanies?.map(
        (jointCompany) => ({
          ...jointCompany,
          PercentageOfShares:
            totalShares > 0
              ? (jointCompany.numberSharesOwned / totalShares) * 100
              : 0,
        })
      );

      return {
        ...prevData,
        totalNoOfShares: totalShares,
        shareHolders: updatedShareHolders,
        JointVentureCompanies: updatedJointVentureCompanies,

      };
    });
  };

  const handleSubmit = async () => {
    if (!validateInput()) {
      return;
    }
    let data = false;
    if (sharedata === 0) {
      data = true
    } else {
      data = false
    }

    try {
      setOpen(false);
      await updateOrganization({
        id: nodeData.nodeId,
        data: {
          ...nodeData,
          whollyCompany: data
        }
      }).unwrap();
      toast.success("Group company updated successfully");

      if (deleteopen) {
        setOpenDeleteModal(true);
      }
    } catch (error) {
      console.error("Error updating node:", error);
      toast.error("Failed to update node");
    }
  };

  const deleteData = async () => {
    try {
      setOpen(false);
      await deleteOrganization({ id: node.nodeId, isRoot: false }).unwrap();
      setDeleteopen(false);
      toast.success("Group company is deleted successfully");
    } catch (error) {
      console.error("Error delete node:", error);
      toast.error(
        error?.data?.message || error?.error || "Failed to delete company"
      );
    }
  };

  useEffect(() => {
    if (allorganization && allorganization.length > 0) {
      const currentRoot = allorganization?.filter((org) => org.isRoot === false && org.isBranch === false && !org?.data?.jointcompany) || [];
      setChildOrganizations(currentRoot);
      setLoading(false);
    }
  }, [allorganization]);

  const handleSearchChange = (event) => {
    const currentRoot = allorganization?.filter((org) => org.isRoot === false && org.isBranch === false && !org?.data?.jointcompany) || [];
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);

    if (query !== "") {
      const filtered = currentRoot.filter((org) => {
        return (
          org.data?.companyName?.toLowerCase().includes(query) ||
          org.data?.location?.name?.toLowerCase().includes(query) ||
          org.data?.BusinessNature?.toLowerCase().includes(query) ||
          groupfilter(org.data?.BusinessGroup)?.toLowerCase().includes(query) ||
          org.data?.totalNoOfShares?.toLocaleString().toLowerCase().includes(query) ||
          org.data?.DeputyManagingDirector?.toLowerCase().includes(query) ||
          org.data?.Chairman?.toLowerCase().includes(query) ||
          org.data?.DeputyChairman?.toLowerCase().includes(query) ||
          org.data?.CompanySecretary?.toLowerCase().includes(query) ||
          org.data?.StatutoryAuditor?.toLowerCase().includes(query) ||
          org.data?.RepresentativeDirector?.toLowerCase().includes(query) ||
          org.data?.LegalRepresentative?.toLowerCase().includes(query) ||
          (org.data?.directors && org.data.directors.some(director => director?.toLowerCase().includes(query)))
        );
      });
      setChildOrganizations(filtered);
    } else {
      setChildOrganizations(currentRoot);
    }
  };


  const handleSortChange = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
  };

  const sortedOrganizations = [...(childOrganizations || [])].sort((a, b) => {
    const valA = sortKey === "totalNoOfShares" ? parseFloat(a.data?.[sortKey]) : a.data?.[sortKey];
    const valB = sortKey === "totalNoOfShares" ? parseFloat(b.data?.[sortKey]) : b.data?.[sortKey];

    if (sortOrder === "asc") {
      return valA > valB ? 1 : -1;
    } else {
      return valA < valB ? 1 : -1;
    }
  });

  const total = sortedOrganizations?.length || 0;
  const paginatedOrganizations = sortedOrganizations?.slice((page - 1) * pageSize, page * pageSize);

  const enrichedOrganizations = paginatedOrganizations?.map((org, index) => ({
    ...org,
    data: {
      ...(org.data || {}),
      index: (page - 1) * pageSize + index + 1,
      directors: Array.isArray(org.data?.directors) ? org.data.directors.join(",") : "",
      directorsLength: Array.isArray(org.data?.directors) ? org.data.directors.length : 0,
      shareHoldersLength: Array.isArray(org.data?.shareHolders) ? org.data.shareHolders.length : 0,
    },
  }));
  const handleSelectRow = (id) => {
    //// console.log(id, "this is id for select the value")
    setSelected((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected?.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSelectAll = (event) => {
    console.log(event.target.checked, "this is checked value")
    console.log("enrichedOrganizations.length", enrichedOrganizations?.length)
    console.log("selected.length", selected.length)
    console.log("every check", enrichedOrganizations?.every(org => selected.includes(org.id)))
    if (event.target.checked) {
      const allIds = enrichedOrganizations?.map((org) => org.id);
      setSelected(allIds);
    } else {
      setSelected([]);
    }
  };

  const isSelected = (id) => selected.includes(id);
  const generateReport = () => {
    const allorg = enrichedOrganizations?.filter(item => selected.includes(item.id));
    console.log("allorg", allorg[0]);
    const tableColumn = [
      "ID",
      "Company Name",
      "Business Group",
      "Business Nature",
      "Incorporation Date",
      "Directors",
      "Chairman",
      "Deputy Chairman",
      "Managing Director",
      "Deputy Managing Director",
      "Representative Director",
      "Resident Director",
      "Legal Representative",
      "Company Secretary",
      "Statutory Auditor",
      "Authorized Capital",
      "Issued Paid-up Capital",
      "Par Value of Shares",
      "Total Paid Up Premium to Shares",
      "Remarks",
      "Location",
      "Shareholders",
    ];
    // "Shareholders (companyName -- shares -- percentage%)",

    const columnWidths = [
      10, 50, 60, 50, 30, 40, 50, 50, 50, 50, 50, 50, 60, 60, 50, 50, 50, 80, 80, 80, 80, 80, 80
    ];
    const stripHtmlTags = (html) => html.replace(/<[^>]*>/g, "");

    const tableWidth = columnWidths.reduce((a, b) => a + b, 0);
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [tableWidth + 20, 297],
    });
    const tableRows = [];
    allorg?.forEach((item, index) => {
      const shareHolders = item?.data?.shareHolders || [];
      const jointVentures = item?.data?.JointVentureCompanies || [];

      const shareholderDetails = shareHolders.map((sh) => {
        const childOrg = enrichedOrganizations.find((org) => org.id === sh.childId);
        const companyName = childOrg?.data?.companyName || sh.childId;
        const shares = sh.numberSharesOwned
          ? Number(sh.numberSharesOwned).toLocaleString()
          : "0";
        const percentage = Number((sh.PercentageOfShares || 0).toFixed(3))
        return `(${companyName}-${shares}-${percentage}%)`;
      });

      const jointVentureDetails = jointVentures.map((jv) => {
        const shares = jv.numberSharesOwned
          ? Number(jv.numberSharesOwned).toLocaleString()
          : "0";
        const percentage = Number((jv.PercentageOfShares || 0).toFixed(3))
        return `(${jv.companyName}[JV]-${shares}-${percentage}%)`;
      });

      const allDetails = [
        ...shareholderDetails,
        ...jointVentureDetails,
      ];
      const shareHoldersRow =
        allDetails.length > 0 ? allDetails.join("&&") : "----";
      const orderData =
        [
          index + 1, // ID
          item?.data?.companyName || "----", // Company Name
          groupfilter(item?.data?.BusinessGroup?.toString()) || "----",
          item?.data?.BusinessNature || "----",
          item?.data?.Incorporationdate || "----",
          item?.data?.directors,
          item?.data?.Chairman || "----",
          item?.data?.DeputyChairman || "----",
          item?.data?.ManagingDirector || "----",
          item?.data?.DeputyManagingDirector || "----",
          item?.data?.RepresentativeDirector || "----",
          item?.data?.ResidentDirector || "----",
          item?.data?.LegalRepresentative || "----",
          item?.data?.CompanySecretary || "----",
          item?.data?.StatutoryAuditor || "----",
          `${item?.data?.AuthorizedCapital} ${item?.data?.CapitalCurrency}` || "----",
          `${item?.data?.TotalPaidUpCapital} ${item?.data?.registerCurrency}` || "----",
          `${item?.data?.ParValueofShares} ${item?.data?.ParCurrency}` || "----",
          `${item?.data?.TotalPaidUpPremiumtoShares} ${item?.data?.TotalCurrency}` || "----",
          stripHtmlTags(item?.data?.Remarks || "----"), // Strip HTML tags from Remarks
          item?.data?.location
            ? `${item?.data?.location?.address}, ${item?.data?.location?.countryName}`
            : "----", // Location
          shareHoldersRow || "----", // Shareholders
        ];
      tableRows.push(orderData);
    });
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      columnStyles: columnWidths.reduce((acc, width, idx) => {
        acc[idx] = { cellWidth: width };
        return acc;
      }, {}),
      styles: { overflow: 'linebreak' },
      pageBreak: 'auto',
    });
    doc.text("Companies Report", 14, 15);
    doc.save(`company_report_${getHongKongTimestamp()}.pdf`);
  };
  const generateExcel = () => {
    // Filter selected organizations
    const allorg = enrichedOrganizations?.filter(item => selected.includes(item.id));

    // Define table columns
    const tableColumn = [
      "ID",
      "Company Name",
      "Business Group",
      "Business Nature",
      "Incorporation Date",
      "Directors",
      "Chairman",
      "Deputy Chairman",
      "Managing Director",
      "Deputy Managing Director",
      "Representative Director",
      "Resident Director",
      "Legal Representative",
      "Company Secretary",
      "Statutory Auditor",
      "Authorized Capital",
      "Issued Paid-up Capital",
      "Par Value of Shares",
      "Total Paid Up Premium to Shares",
      "Remarks",
      "Location",
      "Shareholders",
    ];

    // Define column widths
    const columnWidths = [
      10, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 20, 20, 25, 25, 25, 25, 25
    ];
    const stripHtmlTags = (html) => html.replace(/<[^>]*>/g, "");
    // Prepare data for Excel rows
    const tableRows = allorg?.map((item, index) => {
      const shareHolders = item?.data?.shareHolders || [];
      const jointVentures = item?.data?.JointVentureCompanies || [];

      const shareholderDetails = shareHolders.map((sh) => {
        const childOrg = enrichedOrganizations.find((org) => org.id === sh.childId);
        const companyName = childOrg?.data?.companyName || sh.childId;
        const shares = sh.numberSharesOwned
          ? Number(sh.numberSharesOwned).toLocaleString()
          : "0";
        const percentage = Number((sh.PercentageOfShares || 0).toFixed(3))
        return `(${companyName}-${shares}-${percentage}%)`;
      });

      const jointVentureDetails = jointVentures.map((jv) => {
        const shares = jv.numberSharesOwned
          ? Number(jv.numberSharesOwned).toLocaleString()
          : "0";
        const percentage = Number((jv.PercentageOfShares || 0).toFixed(3))
        return `(${jv.companyName}[JV]-${shares}-${percentage}%)`;
      });

      const allDetails = [
        ...shareholderDetails,
        ...jointVentureDetails,
      ];
      const shareHoldersRow =
        allDetails.length > 0 ? allDetails.join("&&") : "----";
      return [
        index + 1, // ID
        item?.data?.companyName || "----", // Company Name
        groupfilter(item?.data?.BusinessGroup?.toString()) || "----",
        item?.data?.BusinessNature || "----",
        item?.data?.Incorporationdate || "----",
        item?.data?.directors,
        item?.data?.Chairman || "----",
        item?.data?.DeputyChairman || "----",
        item?.data?.ManagingDirector || "----",
        item?.data?.DeputyManagingDirector || "----",
        item?.data?.RepresentativeDirector || "----",
        item?.data?.ResidentDirector || "----",
        item?.data?.LegalRepresentative || "----",
        item?.data?.CompanySecretary || "----",
        item?.data?.StatutoryAuditor || "----",
        `${item?.data?.AuthorizedCapital} ${item?.data?.CapitalCurrency}` || "----",
        `${item?.data?.TotalPaidUpCapital} ${item?.data?.registerCurrency}` || "----",
        `${item?.data?.ParValueofShares} ${item?.data?.ParCurrency}` || "----",
        `${item?.data?.TotalPaidUpPremiumtoShares} ${item?.data?.TotalCurrency}` || "----",
        stripHtmlTags(item?.data?.Remarks || "----"), // Strip HTML tags from Remarks
        item?.data?.location
          ? `${item?.data?.location?.address}, ${item?.data?.location?.countryName}`
          : "----", // Location
        shareHoldersRow || "----", // Shareholders
      ]
    }

    );

    // Generate worksheet and apply column width
    const worksheet = XLSX.utils.aoa_to_sheet([tableColumn, ...tableRows]);
    worksheet["!cols"] = columnWidths?.map(width => ({ wch: width })); // Set column widths
    // Apply bold style to the header row
    tableColumn?.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // Encode cell address (row 0 for header)
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        font: {
          bold: true, // Set font to bold
        },

      };
    });
    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Companies Report");

    // Export to Excel file
    XLSX.writeFile(workbook, `company_report_${getHongKongTimestamp()}.xlsx`);
  };






  const handleJointChange = (index, field, value) => {
    setNodeData(prev => ({
      ...prev,
      JointVentureCompanies: prev.JointVentureCompanies.map((c, i) =>
        i === index ? { ...c, [field]: value, ...(field === "numberSharesOwned" && { PercentageOfShares: (value / prev.totalNoOfShares) * 100 }) } : c
      ),
    }));
  };

  const deleteJoint = (index) => {
    setNodeData((prev) => ({
      ...prev,
      JointVentureCompanies: prev.JointVentureCompanies?.filter((_, i) => i !== index),
    }));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => {
    selected.length === 0 ? toast.warning("Please select at least one company") :
      setIsModalOpen(true)
  };
  const hndleClose = () => {
    setIsModalOpen(false);
  };

  const handleAddShareCompany = () => {
    setNodeData((prev) => ({
      ...prev,
      JointVentureCompanies: [
        ...(Array.isArray(prev.JointVentureCompanies) ? prev.JointVentureCompanies : []),
        {
          companyName: "",
          numberSharesOwned: "",
          PercentageOfShares: 0,
        },
      ],
    }));
  };
  const handleCheckbox = (event) => {
    if (event.target.checked === true) {
      setNodeData({
        ...nodeData,
        [event.target.name]: event.target.checked,
      });
      if (!nodeData.JointVentureCompanies || nodeData.JointVentureCompanies.length === 0) {
        handleAddShareCompany();
      }
    } else {
      setNodeData({
        ...nodeData,
        [event.target.name]: event.target.checked,
        JointVentureCompanies: [],
      });
    }
  };
  return <>
    <div>
      <div className="add-new d-flex align-items-end justify-content-end"></div>
      <div className="p-sm-3 h-screen">
        <div>
          <div className="d-flex justify-content-between mb-4">
            <h3 className="fw-bold">Group Companies</h3>
            <div>
              <Tooltip title="Please Select at least one company" arrow placement="right">
                <Button
                  variant="contained"

                  sx={{
                    backgroundColor: "#003B93",
                    color: "white",
                    minWidth: "150px",
                    "&:hover": { backgroundColor: "#002f73" },
                  }}
                  onClick={handleOpen}
                // disabled={selected.length === 0}
                >
                  Generate Report
                </Button>
              </Tooltip>
              <Modal open={isModalOpen} onClose={hndleClose}>
                <Box sx={style} >
                  <Box sx={{
                    display: 'flex',
                    justifyContent: "space-between"
                  }}>
                    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                      Download Report
                    </Typography>
                    <Button
                      sx={{ textTransform: "none", mb: 2, }}
                      onClick={hndleClose}
                      color="primary"
                    >
                      <FaWindowClose />
                    </Button>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Button
                      variant="contained"
                      color="error"
                      startIcon={<FaFilePdf />}
                      onClick={generateReport}
                    >
                      Download PDF
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      startIcon={<FaFileExcel />}
                      onClick={generateExcel}
                    >
                      Download Excel
                    </Button>
                  </Box>

                </Box>
              </Modal>
            </div>
          </div>
          <div className="row mb-md-0 mb-2">
            <div className="col-lg-8 col-12 d-md-flex justify-content-between">
              <Paper
                component="form"
                sx={{ p: '1px 1px', display: 'flex', alignItems: 'center', width: 380 }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}

                  placeholder="Search Organisation"
                  inputProps={{ 'aria-label': 'search organizations' }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                  <SearchIcon />
                </IconButton>
              </Paper>
              <div className="">
                <Select
                  value={sortKey}
                  onChange={(e) => handleSortChange(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  style={{ marginRight: '10px' }}
                  size="small"
                >
                  <MenuItem value="companyName">Company Name</MenuItem>
                  <MenuItem value="totalNoOfShares">Total Issued Shares</MenuItem>
                </Select>
                <IconButton onClick={() => handleSortChange(sortKey)}>
                  {sortOrder === "asc" ? "⬆️" : "⬇️"}
                </IconButton>
              </div>
            </div>
            <div className="col-lg-4 col-12 d-flex justify-content-end gap-2">
              {admin?.permissions.addOrganization && (
                <span className="">
                  <Link
                    to={"/admin/dropdown/parent"}
                    className="btn text-white"
                    style={{ backgroundColor: "#003B93", minWidth: "150px" }}
                  >
                    <FaPlus /> Add New
                  </Link>
                </span>
              )}
            </div>
          </div>
          {['viewSpecificCompanies', 'viewAllOrganization', 'viewCountryBusinessTypeOrganization', 'viewBusinessTypeOrganization'].some(permission => admin?.permissions?.[permission]) && <>
            <div className="w-100 test" style={{ position: 'relative', minHeight: '400px' }}>
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                  <CircularProgress size={50} sx={{ color: '#003B93' }} />
                </Box>
              ) : (
                <TableMuiCustom
                  styleTableTh={{ fontWeight: "bold" }}
                  styleTableContainer={{
                    minWidth: "800px",
                    maxHeight: "74vh", // Set fixed height for the table container
                    overflowX: "auto", // Enable horizontal scroll when content overflows
                  }}
                  TableHead={{
                    borderRadius: "10px",
                    color: "black",
                    fontWeight: "bold",
                  }}
                  styleTableThead={{
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "bold",
                  }}
                  th={{
                    selectitem: <Checkbox
                      indeterminate={selected.length > 0 && selected.length < enrichedOrganizations.length}
                      checked={selected.length > 0 && enrichedOrganizations?.every(org => selected.includes(org.id))}
                      onChange={handleSelectAll}
                    />,
                    index: "ID",
                    companyName: "Company Name",
                    Businessgroup: "Business Group",
                    location: "Location",
                    totalNoOfShares: "Total Issued Shares",
                    editBtn: `${admin?.permissions.editOrganization ? "Edit" : ""}`,
                    treeView: "Tree View",
                    deleteBtn: `${admin?.permissions.deleteOrganization ? "Delete" : ""}`,
                    branchView: "Branches"
                  }}
                  td={enrichedOrganizations}
                  customFields={[
                    {
                      name: "selectitem",
                      data: (value, row) => (
                        <Checkbox
                          checked={isSelected(row.nodeId)}
                          onChange={() => handleSelectRow(row.nodeId)}
                        />
                      ),
                    },
                    {
                      name: "companyName",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}
                          onClick={() => {
                            // console.log("this is row data", row)
                            const data = allorganization?.find((item) => item.id === row.nodeId)
                            setSingleData(data?.data)
                            setDetail(true)

                          }}
                        >
                          {row?.companyName}
                        </Box>
                      ),
                    },
                    {
                      name: "Businessgroup",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-center align-items-center" style={{ cursor: 'pointer' }} >
                          {groupfilter(row?.BusinessGroup)}
                        </Box>
                      ),
                    },
                    {
                      name: `${admin?.permissions.editOrganization ? "editBtn" : ""}`,
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          <button
                            onClick={() => {
                              setNodeData({
                                ...row,
                                totalNoOfShares: Number(row.totalNoOfShares) || 0,
                                shareHolders: row.shareHolders,
                                directors: row.directors.split(",") || [],
                              });
                              dispatch({
                                type: "alertchange", payload: {
                                  id: row?.nodeId,
                                  message: "Another users also edit this business group"
                                }
                              })
                              setOpen(true);
                              setDeleteopen(false);
                            }}

                            style={{ backgroundColor: "#003B93", color: "white" }}
                            className="btn"
                          >
                            Edit
                          </button>
                        </Box>
                      ),
                    },
                    {
                      name: "totalNoOfShares",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          {row.totalNoOfShares?.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </Box>
                      ),
                    },
                    {
                      name: "location",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          {row.location?.address}
                        </Box>
                      ),
                    },
                    {
                      name: `${admin?.permissions.deleteOrganization ? "deleteBtn" : ""}`,
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          <DeleteIcon style={{ fontSize: "30px", color: "#1976d2", cursor: "pointer" }} onClick={() => {
                            setnode(row);
                            // console.log(row,"this is row data")
                            setOpenDeleteModal(true);
                            setDeleteopen(true);
                          }} />
                        </Box>
                      ),
                    },
                    {
                      name: "branchView",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          <button
                            onClick={() => {
                              setshowBranch(true);
                              setOpenDeleteModal(false);
                              setDeleteopen(false);
                              setnode1(row);
                            }}
                            style={{ backgroundColor: "#003B93", color: "white" }}
                            className="btn"
                          >
                            Branches : {""}
                            <span
                              style={{
                                backgroundColor: "white",
                                color: "#003B93",
                                padding: "3px 6px",
                                borderRadius: "12px",
                                fontWeight: "bold",
                                marginLeft: "6px",
                              }}
                            >
                              {Array.isArray(row.children) ? row.children.filter((child) => child.isBranch).length : 0}
                            </span>
                          </button>
                        </Box>
                      ),
                    },
                    {
                      name: "treeView",
                      data: (value, row) => (
                        <Box className="d-flex justify-content-between align-items-center">
                          <button
                            onClick={() => {
                              console.log(row.nodeId, "this is row data");
                              dispatch(setPlusClicked({ id: row.nodeId, click: true }));
                              // Add a small delay to ensure the state is processed before navigation
                              setTimeout(() => {
                                navigate("/admin/Organisational-Chart");
                              }, 100);
                            }}
                            style={{ backgroundColor: "#003B93", color: "white" }}
                            className="btn"
                          >
                            Tree View
                          </button>
                        </Box>
                      ),
                    },
                  ]}
                />
              )}
            </div>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
              <Box display="flex" alignItems="center">
                <Pagination
                  count={total === 0 ? 1 : Math.ceil((total || 0) / pageSize) || 1}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
              <Typography variant="body2" color="textSecondary">
                Total Companies: {total}
              </Typography>
              <Select
                value={pageSize}
                onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                size="small"
                sx={{
                  color: "#003B93",
                  ".MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#003B93" },
                  ".MuiSvgIcon-root": { color: "#003B93" },
                }}
              >
                {[5, 10, 20, 50, 100, 200]?.map((n) => (
                  <MenuItem key={n} value={n}>{n}</MenuItem>
                ))}
              </Select>
            </Box>
          </>}
        </div>
      </div>
      {open &&
        <AddChildNode
          origin={"parent"}
          nodeData={nodeData}
          handleClose={handleClose}
          open={open}
          handleChange={handleChange}
          errors={errors}
          setErrors={setErrors}
          handleFileChange={handleFileChange}
          handleSubmit={handleSubmit}
          handelDirector={handelDirector}
          handleShareHolders={handleShareHolders}
          handelAddShareHolder={handelAddShareHolder}
          handleAddDirector={handleAddDirector}
          handleTotalSharesChange={handleTotalSharesChange}
          enrichedOrganizations={enrichedOrganizations}
          allorganization1={allorganization}
          sharedata={sharedata}
          setSharedata={setSharedata}
          setNodeData={setNodeData}
          handleJointChange={handleJointChange}
          deleteJoint={deleteJoint}
          handleCheckbox={handleCheckbox}
          handleAddShareCompany={handleAddShareCompany}
        />
      }
      {(open && nodeData?.nodeId === warndata?.objId && warndata?.users?.filter((item) => item !== admin?._id + "-" + deviceId).length > 0) && <WarningModal setOpen={setOpen} setNodeData={setNodeData} users={warndata?.users} usersInfo={warndata?.usersInfo || []} nodeId={warndata?.objId} />}

      {deleteopen && <DeleteNodeChildModel open={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal1} setNodeData={setNodeData} setshowBranch={setshowBranch} setOpen={setOpen} handleClose={setOpenDeleteModal} node={node} setdatafordelete={setdatafordelete} />}
      <LoadingOverlay open={loading || isUpdating || isDeleting} />
      {deleteopen && <DeleteModal setshowBranch={setshowBranch} setOpenDeleteModal={setOpenDeleteModal1} openDeleteModal={openDeleteModal1} deleteData={deleteData} data={node} />}
      <ShowBranchesModel open={showBranch} setOpenDeleteModal={setOpenDeleteModal1} setDeleteopen={setDeleteopen} setnode={setnode1} setNodeData={setNodeData} setOpen={setOpen} handleClose={setshowBranch} node={node1} setnodefordelete={setnode} setdatafordelete={setdatafordelete} />
      {singledata && detail && <OrganizationModal open={detail} onClose={() => { setDetail(false) }} organization={singledata} allorg={allorganization} />}

    </div>
  </>
}
export default ChildOrganizations;